/**
 * Search Modal Focus Management
 */
document.addEventListener('DOMContentLoaded', function () {
    var searchModal = document.getElementById('searchModal');
    
    if (searchModal) {
      var searchTrigger = document.querySelector('.search-trigger');
      
      // Set the return focus element for Bootstrap
      searchModal.addEventListener('show.bs.modal', function() { 
        // Tell Bootstrap where to return focus when modal closes
        if (searchTrigger) {
          searchModal.setAttribute('data-bs-return-focus', searchTrigger);
        }
      });
      
      searchModal.addEventListener('shown.bs.modal', function() { 
        // Focus the search input when modal opens
        var searchInput = searchModal.querySelector('.search-input');
        if (searchInput) {
          searchInput.focus();
        }
      });
      
      searchModal.addEventListener('hide.bs.modal', function() { 
        // Ensure no element inside modal has focus before hiding
        var focusedElement = searchModal.querySelector(':focus');
        if (focusedElement) {
          focusedElement.blur();
        }
      });
      
      
      // Handle backdrop clicks specifically
      searchModal.addEventListener('click', function(e) {
        if (e.target === searchModal) {
          // When backdrop is clicked, immediately blur the modal itself
          searchModal.blur();
          // Also blur any focused element inside
          var focusedElement = searchModal.querySelector(':focus');
          if (focusedElement) {
            focusedElement.blur();
          }
        }
      });
      
    }
  });